var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5675 4.08744L21.135 11.9999L16.5675 19.9124H7.43251L2.86501 11.9999L7.43251 4.08744H16.5675ZM17.5575 2.37744H6.44251L0.88501 11.9999L6.44251 21.6224H17.5575L23.115 11.9999L17.5575 2.37744ZM15.8475 9.11994L14.895 8.16744L12.0075 11.0549L9.11251 8.15994L8.16001 9.11244L11.055 12.0074L8.16751 14.8949L9.12001 15.8474L12.0075 12.9599L14.8875 15.8399L15.84 14.8874L12.96 12.0074L15.8475 9.11994Z",
    fill: "#2A2859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorHexagon);
export default __webpack_public_path__ + "static/media/error-hexagon.839187800fb66c43239c2266772ab063.svg";
export { ForwardRef as ReactComponent };